import { webAuthnSupported } from 'client/util/FeatureSupport';
import UserLoginApi from 'client/api/UserLoginApi';
import webAuthnFormatting from 'client/services/webAuthnFormatting';

export function createWebAuthnService(
  _api,
  _webAuthnSupported,
  _getCredentials,
  _webAuthnFormatting = {
    encodePublicKey: arg => arg,
    decodePublicKeyCredential: arg => arg,
  },
) {
  const { encodePublicKey, decodePublicKeyCredential } = _webAuthnFormatting;

  async function getChallenge({ challenge }) {
    let publicKey;
    let token;

    if (challenge == null) {
      ({ publicKey, token } = await _api.getWebAuthnChallenge());
    } else {
      ({ publicKey, token } = challenge);
    }

    return {
      token,
      publicKey: encodePublicKey(publicKey),
    };
  }

  async function postSignature(publicKeyCredential, token, passwordResetInfo) {
    const decodedPublicKeyCredential = decodePublicKeyCredential(publicKeyCredential);
    const payload = {
      publicKeyCredential: decodedPublicKeyCredential,
      token,
    };

    if (passwordResetInfo && passwordResetInfo.confirmationCode) {
      return _api.resetPassword(
        passwordResetInfo.confirmationCode,
        {
          ...passwordResetInfo,
          ...payload,
        },
      );
    }

    return _api.postWebAuthnSignature(payload);
  }

  return {
    async authenticate(passwordResetInfo, challenge) {
      if (!_webAuthnSupported()) throw new Error('This browser does not support Security Keys.');

      // Get challenge from the api
      const { publicKey, token } = await getChallenge({ challenge });

      // Get the signed Credential from the key
      const options = {
        publicKey,
      };
      const credential = await _getCredentials(options);

      // Verify the credential via the api
      return postSignature(
        credential,
        token,
        passwordResetInfo,
      );
    },
  };
}

// We have to wrap this instead of just passing it because it's object reference must be preserved
const getCredentials = (...props) => navigator.credentials.get(...props);
export default createWebAuthnService(
  UserLoginApi, webAuthnSupported, getCredentials, webAuthnFormatting,
);
